import ENV from 'nightwatch-web/config/environment';

const isDev = ENV.environment === 'development';

export default isDev;
